'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { motion } from 'motion/react';
import { TracingBeam } from '@/components/ui/tracing-beam';
import { howItWorksBottomCtaLabel } from '@/lib/invite-only';
const STEPS = [{
  number: '1',
  title: 'Build in dashboard',
  copy: 'Sign up, build your project, upload media, and craft sequences.',
  image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=800',
  imageAlt: 'Admin dashboard with project and media setup'
}, {
  number: '2',
  title: 'Share link / QR',
  copy: 'Generate a public link; crew opens on prop devices—they auto-download assets and wait.',
  image: 'https://images.unsplash.com/photo-1558655146-d09347e92766?q=80&w=800',
  imageAlt: 'QR code or URL being shared to devices'
}, {
  number: '3',
  title: 'Trigger live',
  copy: 'Live on set: Hit play—watch everything align perfectly.',
  image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=800',
  imageAlt: 'Admin triggering playback, screens updating in sync'
}] as const;
export function HowItWorks() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <motion.h2 id="how-it-works-heading" initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="font-heading text-center text-3xl font-bold text-white md:text-4xl">Prep → Share → Trigger</motion.h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TracingBeam className="mt-16"><div className="space-y-16 md:space-y-24">{STEPS.map(_temp)}</div></TracingBeam>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    t3 = {
      opacity: 1
    };
    t4 = {
      once: true
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section id="how-it-works" className="scroll-mt-20 border-t border-[var(--landing-border)] py-24 px-4" aria-labelledby="how-it-works-heading"><div className="mx-auto max-w-4xl">{t0}{t1}<motion.div initial={t2} whileInView={t3} viewport={t4} className="mt-16 text-center"><Link href="/signup" className="inline-block rounded-xl bg-[var(--landing-accent-red)] px-8 py-3.5 font-heading font-semibold text-white shadow-[0_0_24px_-4px_rgba(255,77,77,0.3)] transition hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-[var(--landing-accent-red)] focus:ring-offset-2 focus:ring-offset-black">{howItWorksBottomCtaLabel()}</Link></motion.div></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(step) {
  return <motion.div key={step.number} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4
  }} className="relative flex flex-col gap-8 md:flex-row md:items-center md:gap-12"><div className="relative shrink-0 md:w-2/5"><div className="relative aspect-video overflow-hidden rounded-xl border border-[var(--landing-border)] bg-[var(--landing-border)]"><Image src={step.image} alt={step.imageAlt} fill={true} className="object-cover" sizes="(max-width: 768px) 100vw, 40vw" /></div><span className="absolute -left-2 -top-2 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--landing-accent-red)] font-heading text-xl font-bold text-white shadow-lg" aria-hidden={true}>{step.number}</span></div><div className="flex flex-col justify-center"><h3 className="font-heading text-2xl font-bold text-white">{step.title}</h3><p className="mt-3 text-lg text-[var(--landing-muted)]">{step.copy}</p></div></motion.div>;
}